import AbacusModal from "@/components/AbacusModal/index.vue";
import { Equipment, EquipmentType, Extractor, RotationType } from "@/models/equipment.model";
import { calculateDebitFromAbacus } from "@/services/balanceSheet.service";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {
    AbacusModal,
  },
})
export default class EquipmentDetails extends Vue {
  @Prop() equipmentType!: EquipmentType;
  @Prop() equipment!: Equipment;
  @Prop() categoryTitle!: string;
  @Prop({ default: false, type: Boolean }) stacked!: boolean;

  get rotationType(): string {
    if (this.isExtractor) {
      if ((this.equipment as Extractor).rotation_type === RotationType.variable) {
        return this.$t("components.equipmentPage.equipmentDisplay.rotationVariable").toString();
      } else {
        return this.$t("components.equipmentPage.equipmentDisplay.rotationSet").toString();
      }
    } else {
      return "";
    }
  }

  get defaultImage(): string {
    return Vue.prototype.defaultImg;
  }

  /**
   * the value of flow at the base depression chosed in settings vue (in m³/h)
   */
  get defaultFlow(): number {
    if (this.equipment.abacus) {
      
      return calculateDebitFromAbacus(this.equipment.abacus, this.baseDepression);
    }
    return 0;
  }

  get isAirLock(): boolean {
    return (
      this.equipmentType === EquipmentType.wastesAirLock ||
      this.equipmentType === EquipmentType.workersAirLock
    );
  }

  get isExtractor(): boolean {
    return this.equipmentType === EquipmentType.extractor;
  }

  get isAirEntry(): boolean {
    return this.equipmentType === EquipmentType.eacm || this.equipmentType === EquipmentType.ear;
  }

  /**
   * If the user has selected a custom equipment, we don't display the same datas.
   */
  get isCustom(): boolean {
    return this.equipment.type === EquipmentType.custom;
  }

  /**
   * Show Abacus modal
   */
  showAbacus(): void {
    this.$bvModal.show(`showAbacus-${this.equipment.type}-${this.equipment.id}`);
  }

  /**
   * Hide Abacus modal
   */
  onAbacusClose(): void {
    this.$bvModal.hide(`showAbacus-${this.equipment.type}-${this.equipment.id}`);
  }

  get baseDepression(): number {
    return store.state.settingsModule.settings.depressionValuetoMaintain;
  }
}
